import { formatCellValue } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import type { ContractFacility } from "@/lib/coach-manager/types";

export function FacilitiesTable({ facilities }: { facilities: ContractFacility[] }) {
  if (facilities.length === 0) return null;

  return (
    <DataTable headers={[{ label: "Facility" }]}>
      {facilities.map((facility) => (
        <tr
          key={`${facility.ContractMovementID}-${facility.Facility}`}
          className="border-b last:border-b-0"
        >
          <td className="px-4 py-2">{formatCellValue(facility.Facility)}</td>
        </tr>
      ))}
    </DataTable>
  );
}
